import { Component } from '@angular/core';

@Component({
  selector: 'app-footer',

  templateUrl: './footer.component.html',

  styleUrls: ['./footer.component.css'],
})
export class FooterComponent {
  lst_Contact = [
    {
      title: 'دفتر منطقه آراد قصر شیرین',
      description:
        ' کرمانشاه، شهرستان قصرشیرین، دهستان فتح آباد، پاسگاه مرزی پرویزخان، کوچه بازارچه مرزی پرویزخان، پلاک 0',
    },
    {
      title: 'دفتر ویگو',
      description:
        'تهران, سهروردی شمالی, خیابان خرمشهر, خیابان عربعلی, کوچه ابراهیمی, پلاک 24 تلفن:88743090',
    },
  ];
}
